import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "career" }
const _hoisted_2 = {
  key: 0,
  class: "toast"
}
const _hoisted_3 = {
  key: 1,
  class: "confirm-toast-overlay"
}
const _hoisted_4 = { class: "career-jobs" }
const _hoisted_5 = { class: "career-form" }
const _hoisted_6 = { class: "popup-box" }
const _hoisted_7 = { class: "file-upload-wrapper" }
const _hoisted_8 = { class: "upload-btn" }
const _hoisted_9 = { class: "file-upload-wrapper" }
const _hoisted_10 = { class: "upload-btn" }
const _hoisted_11 = { class: "checkbox-label" }

import '@/assets/styles/career.css';
import {ref} from "vue";
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'CareerView',
  setup(__props) {

const form = ref({
  name: "",
  forename: "",
  email: "",
  number: "",
  position: "Pflegefachkraft",
  resume: null as File | null,
  cover: null as File | null,
  data: false
});

const showForm = ref(false);
const showToast = ref(false);
const toastMessage = ref("");
const submitted = ref(false);
const error = ref('');
const showConfirmToast = ref(false);

// Datei hochladen
const handleFileUpload = (event: Event, type: "resume" | "cover") => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    form.value[type] = target.files[0];
  }
};

// Wird nur beim Klick auf „Bewerbung absenden“ ausgelöst → öffnet nur Dialog
const submitForm = async () => {
  showConfirmToast.value = true;
};

// Wenn Nutzer „Ja“ klickt → Formular wirklich senden
const confirmSubmission = async () => {
  showConfirmToast.value = false;
  error.value = '';

  try {
    const formData = new FormData();
    formData.append('name', form.value.name);
    formData.append('forename', form.value.forename);
    formData.append('email', form.value.email);
    formData.append('number', form.value.number);
    formData.append('position', form.value.position);

    if (form.value.resume) formData.append('resume', form.value.resume);
    if (form.value.cover) formData.append('cover', form.value.cover);

    const res = await axios.post("/api/application", formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    });

    submitted.value = true;
    toastMessage.value = "Ihre Bewerbung wurde übermittelt.";
    showToast.value = true;

    console.log("Antwort: ", res.data);

    setTimeout(() => showToast.value = false, 4000);
    resetForm();
    showForm.value = false;

  } catch (err) {
    error.value = 'Fehler beim Versenden';
    console.error(err);
  }
};

const cancelSubmission = () => {
  showConfirmToast.value = false;
};

const resetForm = () => {
  form.value = {
    name: "",
    forename: "",
    email: "",
    number: "",
    position: "Pflegefachkraft",
    resume: null,
    cover: null,
    data: false
  };
};

const openForm = (position: string) => {
  form.value.position = position.toLowerCase().replace(/\s/g, '-');
  showForm.value = true;
};

const closeForm = () => {
  showForm.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(toastMessage.value), 1))
      : _createCommentVNode("", true),
    (showConfirmToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", { class: "confirm-toast-box" }, [
            _cache[10] || (_cache[10] = _createElementVNode("p", null, "Sind Sie sicher, dass Sie die Bewerbung jetzt abschicken möchten?", -1)),
            _createElementVNode("div", { class: "confirm-toast-buttons" }, [
              _createElementVNode("button", {
                class: "confirm-btn",
                onClick: confirmSubmission
              }, "Ja"),
              _createElementVNode("button", {
                class: "cancel-btn",
                onClick: cancelSubmission
              }, "Abbrechen")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[27] || (_cache[27] = _createElementVNode("section", { class: "hero-career" }, [
      _createElementVNode("h1", null, "Karriere bei Pflegedienst Gallus Pflegedienst e.K."),
      _createElementVNode("p", null, "Wir benötigen Verstärkung, trete jetzt unserem Team bei! ")
    ], -1)),
    _createElementVNode("section", _hoisted_4, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Offene Stellen", -1)),
      _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Klicke auf die passende Stelle, um dich direkt zu bewerben.", -1)),
      _createElementVNode("div", {
        class: "job-card",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm('pflegefachkraft')))
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("h3", null, "Pflegefachkraft (m/w/d)", -1),
        _createElementVNode("p", null, "Wir suchen aktuell eine erfahrene Pflegefachkraft zur Verstärkung unseres Teams.", -1)
      ]))]),
      _createElementVNode("div", {
        class: "job-card",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openForm('ausbildung')))
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("h3", null, "Ausbildung zur Pflegefachkraft", -1),
        _createElementVNode("p", null, "Start der Ausbildung ab nächstem Jahr – bewirb dich initiativ.", -1)
      ]))])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _withDirectives(_createElementVNode("div", {
        class: "popup-overlay",
        onClick: _withModifiers(closeForm, ["self"])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeForm
          }, "×"),
          _cache[26] || (_cache[26] = _createElementVNode("h2", null, "Jetzt Bewerben", -1)),
          _createElementVNode("form", {
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _createElementVNode("label", null, [
              _cache[15] || (_cache[15] = _createTextVNode(" Name: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.name) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, form.value.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createTextVNode(" Vorname: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.forename) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, form.value.forename]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[17] || (_cache[17] = _createTextVNode(" E-Mail: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, form.value.email]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[18] || (_cache[18] = _createTextVNode(" Telefonnummer: ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.number) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, form.value.number]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[20] || (_cache[20] = _createTextVNode(" Position: ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.position) = $event)),
                required: ""
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("option", { value: "pflegefachkraft" }, "Pflegefachkraft", -1),
                _createElementVNode("option", { value: "ausbildung" }, "Ausbildung zur Pflegefachkraft", -1)
              ]))], 512), [
                [_vModelSelect, form.value.position]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[21] || (_cache[21] = _createTextVNode(" Lebenslauf (PDF): ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(form.value.resume ? form.value.resume.name : "PDF auswählen…"), 1),
                _createElementVNode("input", {
                  type: "file",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (handleFileUpload($event, 'resume'))),
                  accept: ".pdf"
                }, null, 32)
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[22] || (_cache[22] = _createTextVNode(" Anschreiben (PDF): ", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(form.value.cover ? form.value.cover.name : "PDF auswählen…"), 1),
                _createElementVNode("input", {
                  type: "file",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (handleFileUpload($event, 'cover'))),
                  accept: ".pdf"
                }, null, 32)
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.data) = $event)),
                required: ""
              }, null, 512), [
                [_vModelCheckbox, form.value.data]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1)),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "checkbox-text" }, [
                _createTextVNode(" Ich stimme der Verarbeitung meiner Daten gemäß "),
                _createElementVNode("a", {
                  href: "/datenschutz",
                  target: "_blank"
                }, "Datenschutzerklärung"),
                _createTextVNode(" zu. ")
              ], -1))
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("button", { type: "submit" }, "Bewerbung absenden", -1))
          ], 32)
        ])
      ], 512), [
        [_vShow, showForm.value]
      ])
    ])
  ]))
}
}

})